<template>
  <div class="flex items-center">
    <label v-if="label"> {{ ___("Switch|"+label+"|content") }}</label>
    <label v-else> {{ ___("Switch|Label|content") }}</label>
    <div
      class="
        w-15
        h-8
        p-1
        mx-3
        flex
        items-center
        bg-black
        rounded-customRadius
        duration-300
        cursor-pointer
      "
      :class="{ 'bg-primary-color': value }"
      :aria-checked="value.toString()"
      @click="toggle"
    >
      <div
        class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
        :class="{ 'translate-x-6': value }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label:String
  },
  methods: {
    toggle() {
      this.$emit("input", !this.value);
    },
  },
};
</script>
